// apolloClient.ts
import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  split,
  defaultDataIdFromObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import auth from '../../components/auth';

const API_URL = import.meta.env.VITE_GRAPHQL_API_URL; // normal host
const UPLOAD_URL = `${import.meta.env.VITE_ADMIN_UPLOAD_BASE_URL}/graphql`; // host for file-upload ops

const httpLink = new HttpLink({
  uri: API_URL,
  headers: { 'X-client-name': 'admin-panel-apollo' },
});

const uploadLink = createUploadLink({
  uri: UPLOAD_URL,
  headers: { 'X-client-name': 'admin-panel-apollo' },
}) as unknown as ApolloLink;
const authLink = setContext((_, { headers }) => {
  const token = auth.getToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const UPLOAD_OPERATIONS = [
  'CreateContentImage',
  'CreatePDF',
  'UpdatePDF',
] as const;

const link = ApolloLink.from([
  authLink,
  split(
    ({ operationName }) =>
      UPLOAD_OPERATIONS.includes((operationName as any) ?? ''),
    uploadLink, // ← multipart / different host
    httpLink, // ← default host
  ),
]);

const cache = new InMemoryCache({
  dataIdFromObject(obj) {
    if (obj.__typename === 'CRMUser') {
      return (
        obj.id +
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (obj.subscription as any)?.id +
        obj.leadId
      );
    }
    return defaultDataIdFromObject(obj);
  },
});

export const apolloClient = new ApolloClient({
  link,
  cache,
});
